// Tipos y helpers para la narrativa estructurada de visita en el paso 2 del
// wizard. Se persiste como `narrativa jsonb` en public.visitas (migration 0034).

export interface VisitaNarrativa {
  descripcion_visita: string;
  descripcion_negociacion: string;
  reqs_area_legal: string;
  observaciones_tecnico: string;
}

export const NARRATIVA_FIELD_MAX = 5000;

export const NARRATIVA_VACIA: VisitaNarrativa = {
  descripcion_visita: '',
  descripcion_negociacion: '',
  reqs_area_legal: '',
  observaciones_tecnico: '',
};

/** True si al menos uno de los 4 campos tiene contenido (después de trim). */
export function narrativaTieneContenido(n: VisitaNarrativa): boolean {
  return (
    n.descripcion_visita.trim().length > 0 ||
    n.descripcion_negociacion.trim().length > 0 ||
    n.reqs_area_legal.trim().length > 0 ||
    n.observaciones_tecnico.trim().length > 0
  );
}

/** Extrae primera línea no vacía como preview (para listas compactas). */
export function narrativaPreview(n: VisitaNarrativa | null | undefined, max = 80): string {
  if (!n) return '';
  const first =
    n.descripcion_visita.trim() ||
    n.descripcion_negociacion.trim() ||
    n.reqs_area_legal.trim() ||
    n.observaciones_tecnico.trim();
  if (!first) return '';
  const oneLine = first.split('\n')[0]?.trim() ?? '';
  return oneLine.length > max ? oneLine.slice(0, max - 1) + '…' : oneLine;
}

/** Coerciona un valor jsonb arbitrario a una VisitaNarrativa segura (defaults vacíos). */
export function coerceNarrativa(raw: unknown): VisitaNarrativa {
  if (raw && typeof raw === 'object') {
    const r = raw as Record<string, unknown>;
    const pick = (k: keyof VisitaNarrativa): string =>
      typeof r[k] === 'string' ? (r[k] as string) : '';
    return {
      descripcion_visita: pick('descripcion_visita'),
      descripcion_negociacion: pick('descripcion_negociacion'),
      reqs_area_legal: pick('reqs_area_legal'),
      observaciones_tecnico: pick('observaciones_tecnico'),
    };
  }
  return { ...NARRATIVA_VACIA };
}

/** datetime-local string (yyyy-MM-ddTHH:mm) en zona local del navegador. */
export function localDatetimeNow(): string {
  const d = new Date();
  const tz = d.getTimezoneOffset() * 60_000;
  return new Date(d.getTime() - tz).toISOString().slice(0, 16);
}

const FECHA_FORMATTER_FULL = new Intl.DateTimeFormat('es-MX', {
  dateStyle: 'medium',
  timeStyle: 'short',
});
const FECHA_FORMATTER_NODE = new Intl.DateTimeFormat('es-MX', {
  day: '2-digit',
  month: 'short',
});

export function formatVisitaFechaFull(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : FECHA_FORMATTER_FULL.format(d);
}

export function formatVisitaFechaNodo(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : FECHA_FORMATTER_NODE.format(d);
}
